import { LayoutComponent } from './layouts/layout.component';
import { Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { NoAuthGuard } from './shared/guards/no-auth.guard';
import { PublishProductsAccessGuard } from './shared/guards/publish-products-access.guard';
import { DataSharingAccessGuard } from './shared/guards/data-sharing-access.guard';
import { SubscriptionGuard } from './shared/guards/subscription.guard';

export const routes: Routes = [

  // Auth (public-only; block if already logged in)
  {
    path: 'auth',
    canActivate: [NoAuthGuard],
    loadChildren: () => import('./auth/auth.routes').then(m => m.routes)
  },
  {
    path: 'subscription',
    loadChildren: () => import('./subscription/subscription.routes').then(m => m.routes)
  },
  {
    path: 'shopify',
    loadChildren: () => import('./shopify/shopify.routes').then(m => m.routes)
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./onboarding/onboarding.routes').then(m => m.routes)
  },
  {
    path: 'lightspeed',
    loadChildren: () => import('./lightspeed/lightspeed.routes').then(m => m.routes)
  },
  {
    path: 'lightspeed-x',
    loadChildren: () => import('./lightspeed-x/lightspeed-x.routes').then(m => m.routes)
  },
  {
    path: 'loyverse',
    loadChildren: () => import('./loyverse/loyverse.routes').then(m => m.routes)
  },
  {
    path: 'feeds',
    loadChildren: () => import('./feeds/feeds.routes').then(m => m.routes)
  },

  {
    path: '',
    canActivate: [AuthGuard, SubscriptionGuard],
    component: LayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

      {
        path: 'dashboard',
        loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.routes)
      },
      {
        path: 'shops',
        loadChildren: () => import('./shop/shop.routes').then(m => m.routes)
      },
      {
        path: 'reports',
        loadChildren: () => import('./reports/reports.routes').then(m => m.routes)
      },
      {
        path: 'products',
        loadChildren: () => import('./products/products.routes').then(m => m.routes)
      },
      {
        path: 'system',
        loadChildren: () => import('./system/system.routes').then(m => m.routes)
      },
      {
        path: 'account',
        loadChildren: () => import('./account/account.routes').then(m => m.routes)
      },
      {
        path: 'ebay',
        loadChildren: () => import('./ebay/ebay.routes').then(m => m.routes)
      },
      {
        path: 'documentation',
        loadChildren: () => import('./documentation/documentation.routes').then(m => m.routes)
      },
      {
        path: 'publish-products',
        canActivate: [PublishProductsAccessGuard],
        loadChildren: () => import('./publish-products/publish-products.routes').then(m => m.routes)
      },
      {
        path: 'data-sharing',
        canActivate: [DataSharingAccessGuard],
        loadChildren: () => import('./data-sharing/data-sharing.routes').then(m => m.routes)
      }
    ]
  },

  // Fallback
  { path: '**', redirectTo: '' }
];
